import { RouteDefinition, useNavigate } from "@solidjs/router";
import { createEffect, lazy, ParentProps } from "solid-js";

import { catchAll } from "./catch-all.routes.js";

const CandidateList = lazy(
  () => import("../components/candidates/CandidateList.js"),
);
const CandidateProfile = lazy(
  () => import("../components/candidates/CandidateProfile.js"),
);
const CandidateEditForm = lazy(
  () => import("../components/candidates/CandidateEditForm.js"),
);
const AdminCandidateList = lazy(
  () => import("../components/candidates/AdminCandidateView.js"),
);

function redirectToAllCandidates(props: ParentProps) {
  const navigate = useNavigate();

  createEffect(() => {
    navigate("/candidates/all");
  });

  return <>{props.children}</>;
}

export const candidatesRoutes: RouteDefinition[] = [
  {
    path: "/candidates",
    children: [
      catchAll("/candidates/all"),
      {
        path: "/all",
        component: () => (
          <CandidateList
            title="All"
            subTitle="Find talent based upon your specific role requirements"
          />
        ),
      },
      {
        path: "/sponsored-uk",
        component: redirectToAllCandidates,
      },
      {
        path: "/sponsored-overseas",
        component: redirectToAllCandidates,
      },
      {
        path: "/non-sponsored",
        component: redirectToAllCandidates,
      },
      { path: "/example", component: () => <CandidateProfile example /> },
      { path: "/:candidateId", component: () => <CandidateProfile /> },
      {
        path: "/:onboardingUserId/edit",
        component: CandidateEditForm,
      },
      { path: "/list", component: AdminCandidateList },
    ],
  },
];
